import * as Scrivito from "scrivito"

export const SocialsWidget = Scrivito.provideWidgetClass("SocialsWidget", {
  attributes: {
    title: "string",
    linkedin: "link",
    twitter: "link",
    youtube: "link",
    facebook: "link",
    xing: "link",
    instagram: "link"
  }
})
